import { FC } from 'react';
import Typography from '@components/common/typography';
import Button from '@components/common/button';
import styles from './styles.module.scss';
import { IModalComponentProps } from '@context/modal_context';
import illustration from '@svg/illustrations/user_inactive.svg';
import { useLocales } from '@hooks/helpers/useLocales';

const UserActivityModal: FC<
    IModalComponentProps<any, { logout: () => void; cancel: () => void }>
> = ({ onSubmit, modalData }) => {
    const { submitLocale } = useLocales();
    return (
        <div className={styles.wrapper}>
            <img src={illustration} alt="" />
            <Typography alignment="center" variant="h4">
                You’re about to be signed out
            </Typography>
            <Typography className={styles.description} alignment="center" variant="body3">
                For your security, you will be automatically signed out after a period of
                inactivity. If you'd like to continue, click 'Stay signed in' before the timer runs
                out.
            </Typography>
            <div className={styles.timer}>
                00:
                {(modalData?.timer || 0) < 10 ? `0${modalData?.timer || 0}` : modalData?.timer || 0}
            </div>
            <div className={styles.actions}>
                <Button
                    size="medium"
                    onClick={() => onSubmit && onSubmit()?.logout()}
                    variant="outlined-primary">
                    {submitLocale('sign_out_now')}
                </Button>
                <Button
                    size="medium"
                    onClick={() => onSubmit && onSubmit()?.cancel()}
                    variant="primary">
                    {submitLocale('stay_signed_id')}
                </Button>
            </div>
        </div>
    );
};

export default UserActivityModal;
